import { createContext, use } from "react";

/**
 * Управление закрытием оверлея изнутри его содержимого (FE-13).
 *
 * Экраны монтируют оверлеи условно (`{open && <Sheet …/>}`), поэтому анимации
 * ухода взяться неоткуда: элемент исчезает из дерева раньше, чем его успевает
 * что-то анимировать. Решение — `Overlay` перехватывает запрос на закрытие:
 * проигрывает уход и только потом дёргает `onClose` экрана.
 *
 * Через контекст этот перехваченный «закрыть» получает содержимое — свайп
 * вниз на шите должен уводить и шит, и затемнение, а не только себя.
 */
interface OverlayApi {
  /** Закрыть с анимацией ухода. */
  requestClose: () => void;
  /** Уход уже идёт — содержимое должно проиграть свою исходящую анимацию. */
  closing: boolean;
}

export const OverlayContext = createContext<OverlayApi>({
  requestClose: () => undefined,
  closing: false,
});

export function useOverlay(): OverlayApi {
  return use(OverlayContext);
}
